import React from "react";
// reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    FormGroup,
    Form,
    Input,
    UncontrolledTooltip,
} from "reactstrap";

// core components
import IndexNavbar from "../components/Navbars/IndexNavbar";
import Footer from "components/Footer/Footer.js";
import StatsSection from "../components/StatsSection";
import FAQ from "../components/Faq";

import MainIllustration from "assets/img/worker_health.svg";
import SecondIllustration from "assets/img/1046717_OL0FBC1.svg";
import ThirdIllustration from "assets/img/7416549_4786.svg";

import OurServices from "../components/OurServices";

export default function LandingPage() {
    React.useEffect(() => {
        document.body.classList.toggle("landing-page");
        // Specify how to clean up after this effect:
        return function cleanup() {
            document.body.classList.toggle("landing-page");
        };
    }, []);
    return (
        <>
            <IndexNavbar/>
            <div className="wrapper">
                <div className="page-header">
                    <img
                        alt="..."
                        className="path"
                        src={require("assets/img/blob.png")}
                    />
                    <img
                        alt="..."
                        className="path2"
                        src={require("assets/img/path2.png")}
                    />
                    <img
                        alt="..."
                        className="shapes triangle"
                        src={require("assets/img/triunghiuri.png")}
                    />
                    <img
                        alt="..."
                        className="shapes wave"
                        src={require("assets/img/waves.png")}
                    />
                    <img
                        alt="..."
                        className="shapes squares"
                        src={require("assets/img/patrat.png")}
                    />
                    <img
                        alt="..."
                        className="shapes circle"
                        src={require("assets/img/cercuri.png")}
                    />
                    <div className="content-center">
                        <Row className="row-grid justify-content-between align-items-center text-left">
                            <Col lg="6" md="6">
                                <h1 className="text-white">
                                    Elit İş Sağlığı <br/>
                                    <span className="text-white">ve Güvenliği</span>
                                </h1>
                                <p className="text-white mb-3">
                                    İşletmenizin ve çalışanlarınızın güvenliği bizim önceliğimizdir. Uzman kadromuzla, mevzuata uygun, yenilikçi ve güvenilir İş Sağlığı ve Güvenliği çözümleri sunuyoruz.
                                </p>

                                <div className="btn-wrapper">
                                    <div className="button-container">
                                        <Button
                                            className="btn-round"
                                            color="primary"
                                            href="#services"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById('services-section').scrollIntoView({ behavior: 'smooth' });
                                            }}
                                        >
                                            Hizmetlerimiz
                                        </Button>
                                        <Button
                                            className="btn-simple btn-round btn-neutral ml-3"
                                            color="default"
                                            href="#contact"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById('contact-section').scrollIntoView({ behavior: 'smooth' });
                                            }}
                                        >
                                            Bize Ulaşın
                                        </Button>
                                    </div>
                                </div>
                            </Col>
                            <Col lg="4" md="5">
                                <img
                                    alt="..."
                                    className="img-fluid"
                                    src={MainIllustration}
                                />
                            </Col>
                        </Row>
                    </div>
                </div>

                <section className="section section-lg" style={{marginTop: -100}}>
                    <Container>
                        <Row className="justify-content-center mb-5">
                            <Col lg="12">
                                <h1 className="text-center">NEDEN BİR OSGB İLE ÇALIŞMALISINIZ?</h1>
                                <br />
                                <Row className="row-grid justify-content-center">
                                    <Col lg="4" className="text-center">
                                        <div className="info">
                                            <div className="icon icon-primary">
                                                <i className="tim-icons icon-money-coins" />
                                            </div>
                                            <h4 className="info-title">Ekonomik Maliyet</h4>
                                            <p>İşyerinizin tehlike sınıfı ve çalışan sayısına karşılık gelen süre için kısmi zamanlı hizmet alırsınız ve daha ekonomik bir maliyetiniz olur.</p>
                                        </div>
                                    </Col>
                                    <Col lg="4" className="text-center">
                                        <div className="info">
                                            <div className="icon icon-info">
                                                <i className="tim-icons icon-single-02" />
                                            </div>
                                            <h4 className="info-title">Uzman Kadro</h4>
                                            <p>Bünyenizde İşyeri Hekimi, İş Güvenliği Uzmanı ve diğer sağlık personeli çalıştırma yükümlülüğünüz ortadan kalkar.</p>
                                        </div>
                                    </Col>
                                    <Col lg="4" className="text-center">
                                        <div className="info">
                                            <div className="icon icon-success">
                                                <i className="tim-icons icon-paper" />
                                            </div>
                                            <h4 className="info-title">Hukuki Güvence</h4>
                                            <p>Yasal olarak yerine getirmeniz gereken tüm sorumluluklarınızı tek bir kuruluştan almış olursunuz. Tüm personelin yasal yükümlülükleri bize aittir.</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <StatsSection />

                <section className="section section-lg">
                    <img
                        alt="..."
                        className="path"
                        src={require("assets/img/path4.png")}
                    />
                    <Container>
                        <Row className="row-grid justify-content-between align-items-center">
                            <Col md="5">
                                <img
                                    alt="..."
                                    src={SecondIllustration}
                                    className="img-fluid floating"
                                />
                            </Col>
                            <Col md="6">
                                <div className="mt-2">
                                    <h1 className="text-white">
                                        İŞ SAĞLIĞI HİZMETLERİ
                                    </h1>
                                    <p className="text-white mb-3">
                                        Çalışanlarınızın sağlığını korumak ve meslek hastalıklarını önlemek için uzman işyeri hekimlerimiz ve sağlık personellerimizle yanınızdayız.
                                    </p>
                                    <ul className="list-unstyled mt-4">
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div className="icon icon-success mb-2">
                                                    <i className="tim-icons icon-check-2" />
                                                </div>
                                                <div className="ml-3">
                                                    <h5 className="mb-0">İşe Giriş ve Periyodik Muayeneler</h5>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div className="icon icon-success mb-2">
                                                    <i className="tim-icons icon-check-2" />
                                                </div>
                                                <div className="ml-3">
                                                    <h5 className="mb-0">Temel İlkyardım ve Sağlık Eğitimleri</h5>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div className="icon icon-success mb-2">
                                                    <i className="tim-icons icon-check-2" />
                                                </div>
                                                <div className="ml-3">
                                                    <h5 className="mb-0">Meslek Hastalıkları Takibi ve Raporlama</h5>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <section className="section section-lg">
                    <Container>
                        <Row className="row-grid justify-content-between align-items-center">
                            <Col md="6">
                                <div className="mt-2">
                                    <h1 className="text-white">
                                        İŞ GÜVENLİĞİ HİZMETLERİ
                                    </h1>
                                    <p className="text-white mb-3">
                                        İş kazalarını en aza indirmek ve güvenli bir çalışma ortamı sağlamak amacıyla tüm tehlike sınıflarında hizmet veriyoruz.
                                    </p>
                                    <ul className="list-unstyled mt-4">
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div className="icon icon-warning mb-2">
                                                    <i className="tim-icons icon-check-2" />
                                                </div>
                                                <div className="ml-3">
                                                    <h5 className="mb-0">Risk Değerlendirmesi ve Analizi</h5>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div className="icon icon-warning mb-2">
                                                    <i className="tim-icons icon-check-2" />
                                                </div>
                                                <div className="ml-3">
                                                    <h5 className="mb-0">Acil Durum Eylem Planları</h5>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="py-2">
                                            <div className="d-flex align-items-center">
                                                <div className="icon icon-warning mb-2">
                                                    <i className="tim-icons icon-check-2" />
                                                </div>
                                                <div className="ml-3">
                                                    <h5 className="mb-0">Temel İş Güvenliği Eğitimleri</h5>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                            <Col md="5">
                                <img
                                    alt="..."
                                    src={ThirdIllustration}
                                    className="img-fluid floating"
                                />
                            </Col>
                        </Row>
                    </Container>
                </section>

                <div id="services-section">
                    <OurServices/>
                </div>

                <section className="section section-lg section-safe">
                    <img
                        alt="..."
                        className="path"
                        src={require("assets/img/path5.png")}
                    />
                </section>


                <section className="section section-lg">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg="12">
                                <h1 className="text-center">Sürecimiz Nasıl İşliyor?</h1>
                                <Row className="row-grid justify-content-center">
                                    <Col lg="3" className="text-center">
                                        <div className="info">
                                            <div className="icon icon-primary">
                                                <i className="tim-icons icon-chat-33" />
                                            </div>
                                            <h4 className="info-title">1. İletişim ve Keşif</h4>
                                            <p>İhtiyaçlarınızı dinliyor ve işletmenize özel bir ön değerlendirme yapıyoruz.</p>
                                        </div>
                                    </Col>
                                    <Col lg="3" className="text-center">
                                        <div className="info">
                                            <div className="icon icon-info">
                                                <i className="tim-icons icon-puzzle-10" />
                                            </div>
                                            <h4 className="info-title">2. Planlama</h4>
                                            <p>İşletmenizin tehlike sınıfına ve yapısına uygun, detaylı bir İSG planı hazırlıyoruz.</p>
                                        </div>
                                    </Col>
                                    <Col lg="3" className="text-center">
                                        <div className="info">
                                            <div className="icon icon-success">
                                                <i className="tim-icons icon-spaceship" />
                                            </div>
                                            <h4 className="info-title">3. Uygulama</h4>
                                            <p>Uzman ekibimizle hazırlanan planı sahada titizlikle uygulamaya başlıyoruz.</p>
                                        </div>
                                    </Col>
                                    <Col lg="3" className="text-center">
                                        <div className="info">
                                            <div className="icon icon-warning">
                                                <i className="tim-icons icon-chart-pie-36" />
                                            </div>
                                            <h4 className="info-title">4. Takip ve Raporlama</h4>
                                            <p>Sürekli denetim, eğitim ve raporlama ile sistemin kusursuz işlemesini sağlıyoruz.</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </section>

                <FAQ />

                <section className="section" id="contact-section" style={{marginTop: 50}}>
                    <Container>
                        <Row className="align-items-center">
                            <Col md="6">
                                <Card className="card-plain">
                                    <CardHeader>
                                        <h1 className="profile-title text-left">İletişim</h1>
                                    </CardHeader>
                                    <CardBody>
                                        <Form>
                                            <Row>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <label>Adınız</label>
                                                        <Input placeholder="Adınız Soyadınız" type="text"/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <label>E-posta Adresiniz</label>
                                                        <Input placeholder="ornek@email.com" type="email"/>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <label>Telefon Numaranız</label>
                                                        <Input placeholder="05XX XXX XX XX" type="text"/>
                                                    </FormGroup>
                                                </Col>
                                                <Col md="6">
                                                    <FormGroup>
                                                        <label>Firma İsmi</label>
                                                        <Input placeholder="Firma Adı" type="text"/>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col md="12">
                                                    <FormGroup>
                                                        <label>Mesajınız</label>
                                                        <Input placeholder="Mesajınızı buraya yazabilirsiniz..." type="textarea" rows="4"/>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                            <Button
                                                className="btn-round float-right"
                                                color="primary"
                                                data-placement="right"
                                                id="tooltip341148792"
                                                type="button"
                                            >
                                                Gönder
                                            </Button>
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="right"
                                                target="tooltip341148792"
                                            >
                                                Mesajınızı Bekliyoruz
                                            </UncontrolledTooltip>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col className="ml-auto" md="4" style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center'}}>
                                <div className="info info-horizontal">
                                    <div className="icon icon-primary">
                                        <i className="tim-icons icon-mobile"/>
                                    </div>
                                    <div className="description">
                                        <h4 className="info-title">Bizi Arayın</h4>
                                        <p>
                                            Elit OSGB <br/>
                                            +90 364 502 10 10 <br/>
                                            Pzt - Cuma, 8:30 - 18:00
                                        </p>
                                    </div>
                                </div>
                                <div className="info info-horizontal mt-4">
                                    <div className="icon icon-primary">
                                        <i className="tim-icons icon-pin"/>
                                    </div>
                                    <div className="description">
                                        <h4 className="info-title">Adresimiz</h4>
                                        <p>
                                            Çepni, Çelik 3. Sk. No:29, 19040 <br/>
                                            Merkez / Çorum
                                        </p>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <div className="mt-5" style={{display: 'flex', justifyContent: 'center', borderRadius: '10px', overflow: 'hidden'}}>
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12139.451109574333!2d34.8577921!3d40.4783007!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4080d704601cdd7b%3A0x273e41bf5e032008!2sEL%C4%B0T%20OSGB%20DANI%C5%9EMANLIK!5e0!3m2!1sen!2str!4v1709896904563!5m2!1sen!2str"
                                width="100%"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Google Maps"
                            ></iframe>
                        </div>

                    </Container>
                </section>
                <Footer/>

            </div>
        </>
    );
}
